import { Component, OnDestroy, OnInit } from '@angular/core';
import { Order } from '../../../order/models/order';
import { Router } from '@angular/router';
import { OrderStateService } from '../../../order/services/order-state.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { environment } from '../../../../../environments/environment';
import { BookingOrderService } from '../../../booking/services/booking-order.service';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { Subscription } from 'rxjs';
declare let gtag: Function;
declare let gtagmanager: Function;
declare let fbq: Function;

@Component({
  selector: 'app-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrls: ['./payment-complete.component.css']
})
export class PaymentCompleteComponent implements OnInit, OnDestroy {

  private _partnerInitializeSubscription: Subscription;

  constructor(
    private router: Router,
    private orderStateService: OrderStateService,
    private bookingOrderService: BookingOrderService,
    private shopSettingsService: ShopSettingsService,
    private partnerStateService: PartnerStateService,
  ) { }

  ngOnInit(): void {
    this.orderStateService.sessionOrderId = 0;
    const order = this.order;

    if (!order.isPaid) {
      return;
    }

    if (this.shopSettingsService.shopSettings.partnerCodePayment) {
      this._partnerInitializeSubscription = this.partnerStateService.initialize().subscribe();
    }

    if (this.shopSettingsService.googleAnalyticsKey) {
      const items = [];

      for (const orderLine of order.orderLines) {
        items.push({
          id: orderLine.id,
          name: orderLine.name,
          category: orderLine.categoryName,
          quantity: orderLine.quantity,
          price: orderLine.price
        });
      }

      gtag('event', 'purchase', {
        transaction_id: order.name,
        affiliation: 'Ticketshop',
        value: order.totalAmount,
        currency: environment.globalSettings.isoCurrencyCode,
        tax: order.totalTax.toFixed(2),
        items,
      });
    }

    if (this.shopSettingsService.gtagGlobalManagerKey) {
      let sendTo = this.shopSettingsService.gtagGlobalManagerKey;
      if (this.shopSettingsService.gtagLocalManagerKey) {
        sendTo = sendTo + '/' + this.shopSettingsService.gtagLocalManagerKey;
      }

      gtagmanager('event', 'conversion', {
        send_to: sendTo,
        transaction_id: order.name,
        value: order.totalAmount,
        currency: environment.globalSettings.isoCurrencyCode
      });
    }

    if (this.shopSettingsService.facebookAnalyticsId) {
      const content = [];
      const location = environment.odooDatabaseName;
      for (const orderLine of order.orderLines) {
        content.push({ id: orderLine.productId, quantity: orderLine.quantity, item_price: orderLine.price });
      }
      const areaAreaItemPackName = this.bookingOrderService.areaAreaItemPack && this.bookingOrderService.areaAreaItemPack.name
        ? this.bookingOrderService.areaAreaItemPack.name
        : this.order.orderType;
      fbq('track', 'Purchase', {
        value: order.totalAmount,
        currency: environment.globalSettings.isoCurrencyCode,
        location,
        content_name: areaAreaItemPackName,
      });
    }
  }

  ngOnDestroy(): void {
    if (this._partnerInitializeSubscription) {
      this._partnerInitializeSubscription.unsubscribe();
      this._partnerInitializeSubscription = null;
    }
  }

  get order(): Order {
    return this.orderStateService.order;
  }

  continueShopping(): void {
    this.router.navigate(['/']);
  }

}
